import { JSONValue } from '@lucidtech/las-sdk-browser';

import { AnthropicIcon, ChatGPTIcon, GoogleGeminiIcon, QwenIcon } from '@/components/icons';
import { ModelMetadata } from '@/store';

export type UserSettings = {
  use_few_shot_learning?: boolean;
  learning_rate?: number;
};

export const USER_SETTINGS_DEFAULT: UserSettings = {
  use_few_shot_learning: true,
  learning_rate: 0.5,
};

export const toNumber = (value: number | number[], defaultValue?: number) => {
  if (typeof value === 'number') {
    return value;
  } else {
    return defaultValue ?? 0;
  }
};

export const CONFIDENCE_VERSIONS = [
  {
    id: 'v1',
    name: 'Version 1',
    value: 'v1',
    hasNewVersion: true,
    hasNewVersionTooltip: 'Confidence v2 is now available with improved accuracy.',
  },
  { id: 'v2', name: 'Version 2', value: 'v2', isDefault: true },
];

export const LLM_MODELS = [
  {
    id: 'sonnet-4.5',
    name: 'Claude Sonnet 4.5',
    value: 'sonnet-4.5',
    icon: <AnthropicIcon />,
  },
  {
    id: 'sonnet-4.0',
    name: 'Claude Sonnet 4.0',
    value: 'sonnet-4.0',
    icon: <AnthropicIcon />,
  },
  {
    id: 'sonnet-3.7',
    name: 'Claude Sonnet 3.7',
    value: 'sonnet-3.7',
    icon: <AnthropicIcon />,
    isDefault: true,
  },
  {
    id: 'qwen3-vl',
    name: 'Qwen 3 VL',
    value: 'qwen3-vl',
    icon: <QwenIcon />,
  },
  {
    id: 'gpt5-o',
    name: 'GPT-5o',
    value: 'gpt5-o',
    icon: <ChatGPTIcon className="opacity-50" />,
    isDisabled: true,
  },
  {
    id: 'gemini-25-pro',
    name: 'Gemini 2.5 Pro',
    value: 'gemini-25-pro',
    icon: <GoogleGeminiIcon className="opacity-50" />,
    isDisabled: true,
  },
];

export const LOW_HIGH = [
  { id: 'low', name: 'Low', value: 'low' },
  { id: 'medium', name: 'Medium', value: 'medium ' },
  { id: 'high', name: 'High', value: 'high' },
];

export const stripReservedKeys = (config: ModelMetadata | JSONValue): ModelMetadata | JSONValue => {
  if (typeof config !== 'object' || Array.isArray(config)) {
    return config;
  }

  const result: ModelMetadata = {};
  for (const key of Object.keys(config || {})) {
    if (key.includes('cradl:') || key.includes('las:')) {
      continue;
    }

    if (config?.[key] != null) {
      result[key] = stripReservedKeys(config[key]);
    }
  }

  return result;
};
